import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import config from '../config'
import { SIZES } from '../styles/theme'
import EntrancePages from '../containers/EntrancePages'

const Page = styled.div`
  /* min-height: 100vh; */
  width: 100vw;
  text-align: center;

  #content {
    position: absolute;
    background-size: cover;
    width: 100%;
    height: 100%;
    display: block;
    background: linear-gradient(0deg, rgba(255, 244, 226, 1) 0%, rgba(253, 187, 45, 1) 100%);
  }

  #header {
    padding-top: 3vh;
    background: linear-gradient(0deg, rgba(255, 244, 226, 1) 0%, rgba(253, 187, 45, 1) 100%);

    h1 {
      color: black;
      font-weight: 600;
      letter-spacing: 1px;
      font-size: 3rem;
      ${SIZES.mobile} {
        font-weight: 500;
        padding-top: 10px;
        font-size: 1.5rem;
      }
    }

    .time-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      text-transform: uppercase;

      .time-card {
        border-top-left-radius: 14px;
        border-top-right-radius: 14px;
        background: rgb(255, 255, 255);
        background: linear-gradient(rgba(255, 255, 255, 1) 0%, rgba(242, 241, 241, 1) 70%, rgba(180, 179, 179, 1) 100%);

        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        min-width: 120px;
        width: 10vw;
        margin: 0 1%;
        margin-top: 5px;
        padding-top: 10px;
        color: #454852;
        p {
          margin-top: 6px;
          margin-bottom: 6px;
          font-weight: 500;
        }
        h2 {
          margin-top: 0;
          font-weight: 700;
          font-size: 3.2rem;
        }
        ${SIZES.mobile} {
          min-width: 120px;
          width: 10vw;
          border-radius: 18px;
          margin: 1.5% 5%;
          border: 4px solid #fff;
          p {
            margin-top: 6px;
            margin-bottom: 6px;
            font-weight: 500;
          }
          h2 {
            margin-top: 0;
            font-weight: 700;
            font-size: 2.2rem;
          }
        }
        @media (max-width: 768px) {
          margin-left: 2%;
          margin-right: 2%;
        }
      }
    }
  }
  .btn {
    display: block;
    margin: 8px 0;
    background: #143e8b;
    color: #ffffff;
    font-weight: 500;
    padding: 4px 24px;
    border-radius: 32px;
    border: 2px solid white;
  }
  .timeup {
    color: white;
    font-weight: 600;
    font-size: 24px;
  }
  #bg {
    bottom: 0;
    padding: 0;

    img#portrait {
      display: none;
    }
    img#landscape {
      display: block;
    }
    img#ipad {
      display: none;
    }
    ${SIZES.mobile} {
      img#portrait {
        display: block;
        margin: 0 auto;
      }
      img#landscape {
        display: none;
      }
    }
    @media screen and (min-width: 768px) {
      img#portrait {
        display: none;
      }
      img#landscape {
        display: none;
      }
      img#ipad {
        display: block;
        margin: 0 auto;
      }
    }
    @media screen and (min-width: 1025px) {
      img#portrait {
        display: none;
      }
      img#landscape {
        display: block;
      }
      img#ipad {
        display: none;
      }
    }
  }
`

export default function CountdownPage() {
  const calculateTimeLeft = () => {
    // year, actual month - 1, day, hour, minute, second, ignore
    // 15 Mar 2021 8.30am (8am)
    const difference = +new Date(2021, 8, 17, 9, 0, 0, 0) - +new Date()
    let timeLeft = {}

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      }
    }

    return timeLeft
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    localStorage.clear()
  }, [])

  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft())
    }, 1000)
  })

  const timerComponents = []

  Object.keys(timeLeft).forEach((interval) => {
    if (isNaN(timeLeft[interval])) {
      return
    }

    timerComponents.push(
      <div className="time-card">
        <p>{interval}</p>
        <h2>{timeLeft[interval]}</h2>
      </div>
    )
  })
  const refreshPage = () => {
    window.location.reload()
  }

  if (!timerComponents.length) {
    return <EntrancePages />
  }

  return (
    <Page>
      <div id="content">
        <div id="header">
          <h2>
            <b>{config.eventName}</b>
          </h2>
          <div className="time-wrapper">
            {timerComponents.length ? (
              timerComponents
            ) : (
              <span className="timeup">
                Time's up!
                <button className="btn" onClick={refreshPage}>
                  Enter Event
                </button>
              </span>
            )}
          </div>
        </div>
        <div id="bg">
          <img id="landscape" src={config.assets.countdown.landscape} width="100%" alt="background" />
          <img id="portrait" src={config.assets.countdown.portrait} width="100%" alt="background" />
          <img id="ipad" src={config.assets.countdown.landscape} width="100%" alt="background" />
        </div>
      </div>
    </Page>
  )
}
